import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import { BonusModel } from '../../../Models/Game/BonusModel';

export class MiniMapBonusController extends AnimationBaseController {
    $model: BonusModel;

    public constructor(@Inject private _options: any,
                       @Inject private _gameLogic: GameLogic) {
        super('MiniMapBonusController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.MINIMAP_SCREEN_JSON,
            libraryName: 'mini_map_pointer',
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this.$model.type);
        this.setScaleByQuery('time', 0, 0);
    }
}
